import { EnumBase } from 'hay-core-react';
class UsuarioLogDispositivoEnum extends EnumBase {
    constructor() {
        super([
            'main.usuariologacesso.dispositivo.smartphone',
            'main.usuariologacesso.dispositivo.tablet',
            'main.usuariologacesso.dispositivo.tv',
            'main.usuariologacesso.dispositivo.desktop',
            'main.usuariologacesso.dispositivo.smartwatch',
            'main.usuariologacesso.dispositivo.desconhecido',
        ]);
    }
}

const instance = new UsuarioLogDispositivoEnum();
export default instance;
